import React, { useEffect, useState } from "react";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";
import QuestionMainSection from "../../components/questions/QuestionMainSection";
import LoadMoreButton from "../../shared/components/LoadMoreButton";
import PageContent from "../../components/questions/PageContent";
import Heading from "../../components/questions/Heading";
import QuestionPostCard from "../../components/questions/QuestionPostCard";
import SideBar from "../../components/questions/SideBar";
import { useQuestionContext } from "../../shared/context/QuestionContext";
import { useTranslation } from "react-i18next";
import ComponentsLoader from "../../components/includes/ComponentsLoader";

export default function Questions() {
  const [questions, setQuestions] = useState([]);
  const [limit, setLimit] = useState(4);
  const [isLoading, setIsLoading] = useState(true);
  const { getQuestionsByFilter } = useQuestionContext();
  const Lng = localStorage.getItem("lang");
  const { t } = useTranslation();
  // Loading more just raises the limit; the effect below refetches.
  // (It used to refetch with the old limit, so the first click added nothing.)
  function viewMore() {
    setLimit(limit + 4);
  }

  useEffect(() => {
    async function fetchQuestions() {
      const response = await getQuestionsByFilter({
        limit: limit,
        filter: {
          status: "published",
        },
      });
      setQuestions(response.data?.questions ?? []);
      setIsLoading(false);
    }
    fetchQuestions();
  }, [getQuestionsByFilter, limit]);

  return (
    <>
      <Heading />
      <PageContent>
        <Seo
          title={copy.questions(currentLang()).title}
          description={copy.questions(currentLang()).description}
          path={urls.sectionPath("questions", currentLang())}
          alternates={urls.alternates((l) => urls.sectionPath("questions", l))}
        />
        <QuestionMainSection>
          {isLoading ? (
            <ComponentsLoader />
          ) : questions.length > 0 ? (
            questions.map((question) => (
              <QuestionPostCard key={question._id} question={question} />
            ))
          ) : (
            <div className="avc-empty">
              <span className="avc-empty__icon">
                <i className="far fa-comments" aria-hidden="true"></i>
              </span>
              <h2 className="avc-empty__title">{t("qa_empty")}</h2>
            </div>
          )}
          {/* A full page means there may be more to load. */}
          {questions.length >= limit && (
            <LoadMoreButton onClick={viewMore} />
          )}
        </QuestionMainSection>
        <SideBar />
      </PageContent>
    </>
  );
}
